var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcDownload = function SvgIcDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ic_download_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 28c7.732 0 14-6.268 14-14S21.732 0 14 0 0 6.268 0 14s6.268 14 14 14Z",
    fill: "#C6CBD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.118 14.42a.775.775 0 0 0 0 1.096l2.334 2.334a.775.775 0 0 0 1.096 0l2.334-2.334a.789.789 0 0 0 0-1.108.789.789 0 0 0-1.109 0l-1.003 1.015V6.416a.782.782 0 0 0-1.563 0v9.007l-1.004-1.015a.775.775 0 0 0-1.096 0l.011.012Zm7.549-3.337h-1.552a.782.782 0 0 0 0 1.563h1.552c.431 0 .781.35.781.782v5.437c0 .431-.35.781-.781.781H9.333a.782.782 0 0 1-.781-.781v-5.437c0-.432.35-.782.781-.782h1.552a.782.782 0 0 0 0-1.563H9.333A2.333 2.333 0 0 0 7 13.416v5.437a2.333 2.333 0 0 0 2.333 2.333h9.334A2.333 2.333 0 0 0 21 18.853v-5.437a2.333 2.333 0 0 0-2.333-2.333Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ic_download_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
};
export default SvgIcDownload;